import React, { Component } from 'react';
import moment from 'moment';
import { Convert } from 'src/helpers';
import styles from './_upcomingTransactions.module.scss';

class UpcomingTransactions extends Component {
  render() {
    const { upcomingTransactions } = this.props;
    return (
      <div className={styles['upcoming-transactions']}>
        <div className={styles['title']}>Upcoming Transactions</div>
        <div className={styles['list-box']}>
          {upcomingTransactions &&
            upcomingTransactions.length > 0 &&
            upcomingTransactions.map((data, index) => (
              <div className={styles['list']} key={index}>
                <div className={styles['left']}>
                  {moment(data?.createdAt, 'Do MMMM, YYYY').isSameOrAfter(moment()) ? (
                    <img src="/images/down-green-arrow.svg" alt="up arrow" />
                  ) : (
                    <img src="/images/up-yellow-arrow.svg" alt="up arrow" />
                  )}
                  {Convert.toCurrencyValue(data?.amount)}
                </div>
                <div className={styles['right']}>{data?.createdAt}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default UpcomingTransactions;
